/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.onlineResources").
controller("DxOnlineResourcePopupController", function NewOnlineResourcePopupController(
	$scope,
	$document,
	$timeout,

	DX_RESOURCE_TYPE,
	DX_NAVIGATION_RESTRICTION,
	DxOnlineResource,
	dxApi,
	dxLocalize,
	dxEvent,

	dxDialog,
	dxDebounce,
	dxYouTubeEmbedService,
	validationService,
	dxAngularConstantHelper
) {
	"use strict";

	/**
	 * Required $scope properties:
	 * - "question", {Question}
	 * - "resourceType", {DX_RESOURCE_TYPE}
	 * Optional $scope properties:
	 * - "onlineResource", {OnlineResource} Include if you want to edit resource.
	 **/

	$scope.dxDialog = dxDialog;
	$scope.DX_RESOURCE_TYPE = DX_RESOURCE_TYPE;
	$scope.DX_NAVIGATION_RESTRICTION = DX_NAVIGATION_RESTRICTION;
	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	var iconMap = {
		youtube: "img/online-resources/icon-youtube.svg",
		url: "img/online-resources/icon-web-page.svg",
		audio: "img/online-resources/icon-audio.svg",
		pdf: "img/online-resources/icon-pdf.svg",
	};

	// Solves the problem when a suggested title is given from the debouncer
	$scope.$watch("title", function updatedTitle(newValue) {
		if (newValue !== "") {
			$scope.urlError = "";

			if ($scope.title !== "") {
				$scope.titleError = "";
			}
		}
	});

	$scope.url = "";
	$scope.title = "";
	$scope.navigationRestriction = DX_NAVIGATION_RESTRICTION.SINGLE_PAGE;
	$scope.hostname = "";
	$scope.titleError = "";
	$scope.suggestedTitle = "";
	$scope.urlError = "";
	$scope.iconUrl = iconMap[$scope.resourceType];
	$scope.showTitleField = false;
	$scope.loadingSpinnerToggle = {};
	$scope.titleLoadingPlaceHolder = "Loading";
	$scope.loadingUrl = false;
	$scope.validatingUrl = false;

	var regExpUrlValidation = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&=]*)/;
	var defaultProtocol = "http://";
	var debouncer = dxDebounce();
	var lastResolvedURL = "";


	$scope.blurUrl = function blurUrl() {
		if (!$scope.url) {
			return;
		}

		if ($scope.url.indexOf("://") === -1) {
			$scope.url = defaultProtocol + $scope.url;
		}

		var domAnchorTag = $document[0].createElement("a");
		domAnchorTag.href = $scope.url;
		$scope.hostname = domAnchorTag.hostname;
	};

	$scope.switchTitle = function switchTitle() {
		$scope.title = $scope.suggestedTitle;
		$scope.suggestedTitle = "";
		$scope.showSuggestedTitle = false;
	};

	$scope.$watch("url", function onUrlChange(url) {
		debouncer.debounce(1000).then(function success() {
			if (regExpUrlValidation.test(url)) {
				dxEvent.create(DX_EVENT_NAME.EventOnlineResourcesURLTyped);
				resolveURL();
			}
		}, angular.noop);
	});

	$scope.$watch("title", function onTitleChange(title) {
		debouncer.debounce(1000).then(function success() {
			if (title !== "") {
				validateTitle(title);
			}
		}, angular.noop);
	});

	function resolveURL() {
		if (lastResolvedURL === $scope.url) {
			return;
		}
		$scope.loadingUrl = true;

		var urlToPost = validationService.preprocessUrl($scope.url);

		dxApi.v1.onlineResources.resolve.post(urlToPost).then(successResolveURL);
		if (!$scope.loadingSpinnerToggle.toggledOn && $scope.title === "") {
			$scope.loadingSpinnerToggle.toggle();
		}
		$scope.titleLoadingPlaceHolder = "Loading";
		lastResolvedURL = urlToPost;
	}

	function successResolveURL(response) {
		if ($scope.loadingSpinnerToggle.toggledOn) {
			$scope.loadingSpinnerToggle.toggle();
		}
		$scope.titleLoadingPlaceHolder = "";

		if (response.data.ok) {
			$scope.urlError = "";
			$scope.showTitleField = true;
			validateTitle(response.data.title);
		} else {
			$scope.urlError = dxLocalize.get("OnlineResource.unreachableURL");
		}

		$scope.loadingUrl = false;
	}

	function validateTitle(title) {
		if (title === "") {
			$scope.titleError = "OnlineResourcePopup.TitleError";
			return false;
		}

		$scope.suggestedTitle = "";
		$scope.titleLoadingPlaceHolder = "";
		$scope.titleError = "";
		$scope.showSuggestedTitle = false;

		if ($scope.title === "") {
			$scope.title = title;
		} else if (title && $scope.title !== title) {
			$scope.showSuggestedTitle = true;
		}

		$scope.suggestedTitle = title;

		return true;
	}

	function validateURL(url) {
		$scope.urlError = "";
		var validUrlLength = url.length > defaultProtocol.length;
		var validUrlProtocol = regExpUrlValidation.test(url);
		var validYoutubeLink = true;

		if ($scope.resourceType === DX_RESOURCE_TYPE.YOUTUBE) {
			try {
				dxYouTubeEmbedService.getVideoID($scope.url);
			} catch (err) {
				validYoutubeLink = false;
			}
		}
		if (!validUrlProtocol && !$scope.loadingUrl) {
			$scope.urlError = "OnlineResourcePopup.UrlErrorProtocol";
		}
		if (!validYoutubeLink) {
			$scope.urlError = "OnlineResourcePopup.YoutubeError";
		}
		if (!validUrlLength) {
			$scope.urlError = "OnlineResourcePopup.UrlErrorEmpty";
		}

		return validUrlLength && validUrlProtocol && validYoutubeLink;
	}

	$scope.validateFields = function validateFields() {
		$scope.validatingUrl = true;

		dxApi.v1.onlineResources.resolve.post($scope.url).then(function resolvedURL(res) {
			if (res.data.ok) {
				var validTitle = validateTitle($scope.title);
				var validURL = validateURL($scope.url);

				if (validTitle && validURL) {
					confirmInput();
				} else {
					$scope.validatingUrl = false;
				}
			} else if (!res.data.ok) {
				$scope.urlError = dxLocalize.get("OnlineResource.unreachableURL");
				$scope.validatingUrl = false;
			}
		});
	};

	function confirmInput() {
		var onlineResource = new DxOnlineResource({
			url: $scope.url,
			type: $scope.resourceType,
			title: $scope.title,
			navigationRestriction: $scope.navigationRestriction,
		});

		if (!$scope.question.onlineResources) {
			$scope.question.onlineResources = [];
		}
		if ($scope.onlineResource) {
			var index = $scope.question.onlineResources.indexOf($scope.onlineResource);
			$scope.question.onlineResources[index] = onlineResource;
		} else {
			$scope.question.onlineResources.push(onlineResource);
		}
		if ($scope.title !== $scope.suggestedTitle) {
			dxEvent.create(DX_EVENT_NAME.EventOnlineResourcesResolvedTitleChanged, [
				{key: "suggestedTitle", value: $scope.suggestedTitle},
				{key: "titleUsed", value: $scope.title},
			]);
		}

		dxDialog.closeMostRecent();
	}

	function init() {
		if ($scope.onlineResource) {
			$scope.url = $scope.onlineResource.url;
			$scope.title = $scope.onlineResource.title;
			$scope.showTitleField = true;
			$scope.navigationRestriction = $scope.onlineResource.navigationRestriction;
			$scope.hostname = $scope.onlineResource.hostname;
			$scope.titleError = "";
			$scope.urlError = "";
			$scope.iconUrl = iconMap[$scope.resourceType];
			$scope.blurUrl();

			//Using timeout here because the loadingSpinner is not set yet.
			$timeout(function time() {
				if ($scope.loadingSpinnerToggle.toggledOn) {
					$scope.loadingSpinnerToggle.toggle();
				}
			});
		}
	}

	init();
});
